import { render, staticRenderFns } from "./CreaGruppo.vue?vue&type=template&id=5d2838cc&scoped=true&slot=tag&slot-scope=props&"
import script from "./CreaGruppo.vue?vue&type=script&lang=js&"
export * from "./CreaGruppo.vue?vue&type=script&lang=js&"
import style0 from "./CreaGruppo.vue?vue&type=style&index=0&id=5d2838cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2838cc",
  null
  
)

export default component.exports